import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useCallback, useMemo } from 'react';

import { useRudderStack } from '@ocx/data-analytics';

import { ExternalBannerDetailsPopupController } from './external-banner-details-popup.controller';
import { ExternalBannerDetailsPopupProps } from './external-banner-details-popup.types';

// eslint-disable-next-line import/no-named-as-default-member -- NiceModal.create is the documented API
const ExternalBannerDetailsPopupModal = NiceModal.create(ExternalBannerDetailsPopupController);

export const useExternalBannerDetailsPopup = () => {
  const { show } = useModal(ExternalBannerDetailsPopupModal);
  const { triggerEvent } = useRudderStack();

  const open = useCallback(
    (props: ExternalBannerDetailsPopupProps) => {
      triggerEvent('external_offer_details_modal_opened', { uuid: props.banner.trackingId });
      show(props);
    },
    [show, triggerEvent],
  );
  return useMemo(() => ({ open }), [open]);
};
